import {getCountryList} from '../../assets/xhr';

let data = {
    ready: false
};
let callbacks = [];

export default function getData(callback){
    if (data.ready){
        callback(data);
    } else{
        callbacks.push(callback);
    }
    if (data.ready || callbacks.length > 1){
        return;
    }
    getCountryList(({country={}, province={}, city = {}, district={}})=>{
        country.child_node= [province];
        
        province.parent_node = country;
        province.child_node = [city];
        
        city.parent_node = province;
        city.child_node = [district];
        
        district.parent_node = city;
        data = {
            ready: true,
            city,
            country,
            province,
            district
        }
        callbacks.forEach((cbk)=>{
            cbk && cbk(data);
        });
        callbacks = [];
    });
    
    
}



// WEBPACK FOOTER //
// ./src/component/AddressOld/data.js